import React from 'react';
import { CategoryImage } from '../../../../types/api/ImageType';

type AnnouncementCategoryImageProps = {
  image?: CategoryImage
};

export function AnnouncementCategoryImage({ image }: AnnouncementCategoryImageProps) {
  return (image
    ? <img className="categories-block__image" src={image.src} alt="" width={image.availableWidths.at(0)} />
    : null
  );
}
